import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Divider,
} from '@mui/material';
import { useLanguage } from '../../i18n/LanguageContext';
import { NextWorkout } from '../../services/api/ProgramApiService';
import { DeloadBadge } from './DeloadBadge';

interface NextWorkoutCardProps {
  nextWorkout: NextWorkout;
}

export const NextWorkoutCard: React.FC<NextWorkoutCardProps> = ({ nextWorkout }) => {
  const { t } = useLanguage();

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
          {t('programs.nextWorkout')}: {nextWorkout.template_name}
        </Typography>
        <Divider sx={{ mb: 1.5 }} />
        {nextWorkout.exercises.map((ex) => (
          <Box
            key={ex.program_exercise_id}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              py: 0.5,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body2">{ex.name}</Typography>
              <DeloadBadge consecutiveFailures={ex.consecutive_failures} />
            </Box>
            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="body2" fontWeight="medium">
                {ex.sets}×{ex.reps} @ {ex.current_weight_kg} kg
              </Typography>
            </Box>
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};
